module.exports = __webpack_public_path__ + "static/sass-73e24896289a49f3365faf66faec2f65.png";